import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ConfirmRegistration } from '../../models/confirmregistration';

import { UserRegistrationService} from '../../../services/user-registration.service';
import { UserLoginService } from '../../../services/user-login.service';
import { LoggedInCallback } from '../../../services/cognito.service';
import { ApplicationDataService } from '../../../services/application.service';
import { ErrorService } from 'services/error.service';

@Component({
  selector: 'app-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.css']
})
export class ConfirmComponent implements OnInit, OnDestroy {
  model: ConfirmRegistration;
  loginLink: string;
  private sub: any;
  processing: boolean = false;

  constructor(public regService: UserRegistrationService, public router: Router, public route: ActivatedRoute, private applicationService: ApplicationDataService, private userService: UserLoginService, private errorService: ErrorService) {}

  ngOnInit() {
    this.model = new ConfirmRegistration();
    this.sub = this.route.params.subscribe(params => {
      this.model.Email = params['username'];
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  onSubmit() {
    this.processing = true;
    this.applicationService.getCaseCorrectEmail(this.model.Email).subscribe(res => this.onEmailCheckResponse(res));
    
  }

  onEmailCheckResponse(caseCorrectEmail: string) {
    if(caseCorrectEmail) {
      this.regService.confirmRegistration(caseCorrectEmail, this.model.ConfirmationCode, this);
    }
    else {
      this.regService.confirmRegistration(this.model.Email, this.model.ConfirmationCode, this);
    }    
  }

  cognitoCallback(message: string, result: any) {
        if (message != null) {
          this.processing = false;
            let errorMessage = message;
            if(errorMessage.toLowerCase().indexOf('not found') >= 0) {
              errorMessage += " Your email is case sensitive. Make sure you are entering it exactly as it appears in your confirmation email.";
            }
            if(errorMessage === "User cannot confirm because user status is not UNCONFIRMED.") {
              errorMessage = "Your email address has already been confirmed. ";
            }

            this.errorService.showError(errorMessage)
        } else {
          if (this.regService._user !== null)
          {
            let userEmail = this.model.Email;
            this.userService.authenticate(this.regService._user.Email, this.regService._user.Password, {cognitoCallback: function(message: string, result: any) {
              let redirectURL = "public/login/" + userEmail;
              window.location.replace(redirectURL);
            }});
          }
          else {
            this.router.navigate(['public/login', this.model.Email]);
          }
            
        }
    }

}
